import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "p-field-radiobutton" }
const _hoisted_4 = { for: "TemperatureType.Celsius" }
const _hoisted_5 = { class: "p-field-radiobutton" }
const _hoisted_6 = { for: "TemperatureType.Fahrenheit" }
const _hoisted_7 = { class: "p-field-checkbox d-flex align-items-center mt-3" }
const _hoisted_8 = { for: "ApplyAllThermostats" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.preferenceLabel)
      ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.preferenceLabel), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.UnitMeasureUpper")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_RadioButton, {
        id: "TemperatureType.Celsius",
        name: "TemperatureType",
        value: _ctx.TemperatureType.Celsius,
        modelValue: _ctx.roomObject.temperatureType,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.temperatureType = $event)),
        disabled: _ctx.readOnly
      }, null, 8, ["value", "modelValue", "disabled"]),
      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.CelsiusDegrees")), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_RadioButton, {
        id: "TemperatureType.Fahrenheit",
        name: "TemperatureType",
        value: _ctx.TemperatureType.Fahrenheit,
        modelValue: _ctx.roomObject.temperatureType,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.roomObject.temperatureType = $event)),
        disabled: _ctx.readOnly
      }, null, 8, ["value", "modelValue", "disabled"]),
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.FahrenheitDegrees")), 1)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_Checkbox, {
        id: "ApplyAllThermostats",
        name: "ApplyAllThermostats",
        modelValue: _ctx.roomObject.isApplyAllCelsiusFahrenheit,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.roomObject.isApplyAllCelsiusFahrenheit = $event)),
        binary: true,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.ApplyAllThermostats")), 1)
    ])
  ]))
}